import { 
  MdConfirmationNumber, 
  MdBarChart, 
  MdSettings, 
  MdLogout,
  MdExpandLess,
  MdExpandMore,
  MdSupportAgent,
  MdGroup,
  MdDescription,
  MdTimer,
  MdLightbulb,
  MdBusiness,
  MdBusinessCenter,
  MdEmail,
  MdAssignment,
  MdEvent,
  MdFolder
} from 'react-icons/md';
import { RxDashboard } from 'react-icons/rx';
import { SlSupport } from "react-icons/sl";
import { TbReportAnalytics } from "react-icons/tb";


import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../../context/LanguageContext';

const Sidebar = ({ isOpen, onToggle, onCloseSidebar, isMobile }) => {
  const navigate = useNavigate();
  const { t } = useLanguage();
  const [isSettingsOpen, setIsSettingsOpen] = useState(false);
  const [isReportsOpen, setIsReportsOpen] = useState(false);
  const [isTimesheetOpen, setIsTimesheetOpen] = useState(false);

  const reportsSubMenu = [
    { icon: <MdBusiness size={14} />, label: t('reports.companyReport'), path: '/reports/company' },
    { icon: <MdSupportAgent size={14} />, label: t('reports.agentReport'), path: '/reports/agent' },
    { icon: <MdFolder size={14} />, label: t('reports.projectReport'), path: '/reports/project' },
    { icon: <MdConfirmationNumber size={14} />, label: t('reports.ticketsReport'), path: '/reports/tickets' },
    { icon: <MdLightbulb size={14} />, label: t('reports.productReport'), path: '/reports/products' },
    { icon: <MdTimer size={14} />, label: t('reports.slaReport'), path: '/reports/sla' },
    { icon: <MdSupportAgent size={14} />, label: t('reports.slaReportByAgent'), path: '/reports/sla-by-agent' },
    { icon: <MdGroup size={14} />, label: t('reports.slaReportByCustomer'), path: '/reports/sla-by-customer' },
  ];

  const settingsSubMenu = [
    { icon: <MdBusinessCenter size={14} />, label: t('settings.departmentSettings'), path: '/settings/departments' },
    { icon: <MdSupportAgent size={14} />, label: t('settings.agentSettings'), path: '/settings/agent' },
    { icon: <MdGroup size={14} />, label: t('settings.customerSettings'), path: '/settings/customer' },
    { icon: <MdDescription size={14} />, label: t('settings.contractSettings'), path: '/settings/contract' },
    { icon: <MdTimer size={14} />, label: t('settings.slaGroups'), path: '/settings/sla' },
    { icon: <MdEmail size={14} />, label: t('settings.smtpSettings'), path: '/settings/smtp' },
    { icon: <MdEvent size={14} />, label: t('settings.workingHoursSettings'), path: '/settings/working-hours' }
  ];

  const timesheetSubMenu = [
    { icon: <MdAssignment size={14} />, label: t('navigation.timesheetEntry'), path: '/timesheet' },
    { icon: <MdBusiness size={14} />, label: t('navigation.companyTimesheetReport'), path: '/timesheet/company-report' },
    { icon: <MdSupportAgent size={14} />, label: t('navigation.userTimesheetReport'), path: '/timesheet/user-report' },
  ];

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    navigate('/admin');
  };

  const menuItems = [
    { key: 'dashboard', icon: <RxDashboard size={18} />, label: t('navigation.dashboard'), path: '/dashboard' },
    { key: 'supportCases', icon: <SlSupport size={18} />, label: t('navigation.supportCases'), path: '/support-cases'},
    { key: 'statistics', icon: <MdBarChart size={18} />, label: t('navigation.statistics'), path: '/statistics' },
    { key: 'projects', icon: <MdFolder size={18} />, label: t('navigation.projects'), path: '/projects' },
    { 
      key: 'timesheet',
      icon: <MdAssignment size={18} />, 
      label: t('navigation.timesheet'), 
      hasSubmenu: true,
      onClick: () => setIsTimesheetOpen(!isTimesheetOpen)
    },
    { 
      key: 'reports',
      icon: <TbReportAnalytics  size={18} />, 
      label: t('navigation.reports'), 
      hasSubmenu: true,
      onClick: () => setIsReportsOpen(!isReportsOpen)
    },
    { 
      key: 'settings',
      icon: <MdSettings size={18} />, 
      label: t('navigation.settings'), 
      hasSubmenu: true,
      onClick: () => setIsSettingsOpen(!isSettingsOpen),
      hasDivider: true 
    },
    { 
      key: 'logout',
      icon: <MdLogout size={18} />, 
      label: t('navigation.logOut'), 
      onClick: handleLogout,
      hasDivider: true
    },
  ];

  return (
    <div className={`
      fixed 
      left-0 
      h-full 
      bg-[#232b3b] dark:bg-gray-800
      transition-all 
      duration-300 
      shadow-[3px_0_8px_rgba(0,0,0,0.15)] 
      border-r 
      border-gray-700 dark:border-gray-600
      flex flex-col
      ${isMobile ? 'z-50' : 'z-10'}
      ${isMobile 
        ? (isOpen ? 'translate-x-0' : '-translate-x-full') + ' w-[290px]'
        : (isOpen ? 'w-[290px]' : 'w-[50px]')
      }
    `}>
      {/* Collapse/Expand butonu - Sadece desktop'ta göster */}
      {!isMobile && (
        <button
          onClick={onToggle}
          className="absolute -right-2.5 top-[26px] bg-[#232b3b] dark:bg-gray-800 p-0.5 shadow-sm border border-gray-700 dark:border-gray-600"
        >
          <MdExpandLess 
            className={`transition-transform duration-300 text-[#8d969d] dark:text-gray-400
              ${!isOpen ? 'rotate-90' : '-rotate-90'}`}
            size={12}
          />
        </button>
      )}
      
      <div className="py-6 flex-1 overflow-y-auto sidebar-scroll" style={{
        scrollbarWidth: 'none', /* Firefox */
        msOverflowStyle: 'none', /* Internet Explorer 10+ */
      }}>
        {menuItems.map((item, index) => (
          <div key={index}>
            {item.hasDivider && (
              <div className={`mx-4 my-2 border-t border-gray-700 dark:border-gray-600 ${!isOpen && 'mx-2'}`} />
            )}
            <div>
              {item.hasSubmenu ? (
                <button
                  onClick={() => {
                    // Eğer menü kapalıysa ve desktop modundaysa, önce menüyü aç
                    if (!isOpen && !isMobile) {
                      onToggle();
                      // Kısa bir gecikme ile sub menüyü aç
                      setTimeout(() => {
                        item.onClick();
                      }, 100);
                    } else {
                      item.onClick();
                    }
                  }}
                  className={`w-full flex items-center py-3 text-[#8d969d] dark:text-gray-400 hover:text-white dark:hover:text-white hover:bg-[#181f27] dark:hover:bg-gray-700 text-base cursor-pointer
                    ${(isOpen || isMobile) ? 'px-6' : 'justify-center px-4'}`}
                >
                  <span className="inline-block">{item.icon}</span>
                  {(isOpen || isMobile) && (
                    <div className="flex items-center justify-between flex-1">
                      <span className="ml-3 transition-opacity duration-300">{item.label}</span>
                      {item.hasSubmenu && (
                        <MdExpandMore 
                          className={`transition-transform duration-300 
                            ${(item.key === 'settings' && isSettingsOpen) || 
                              (item.key === 'reports' && isReportsOpen) ||
                              (item.key === 'timesheet' && isTimesheetOpen) ? 'rotate-180' : ''}`}
                          size={16}
                        />
                      )}
                    </div>
                  )}
                </button>
              ) : (
                <button
                  onClick={item.onClick || (() => {
                    navigate(item.path);
                    if (isMobile && onCloseSidebar) {
                      onCloseSidebar();
                    }
                  })}
                  className={`w-full flex items-center py-3 text-[#8d969d] dark:text-gray-400 hover:text-white dark:hover:text-white hover:bg-[#181f27] dark:hover:bg-gray-700 text-base
                    ${isOpen ? 'px-6' : 'justify-center px-4'}`}
                >
                  <span className="inline-block">{item.icon}</span>
                  {isOpen && (
                    <span className="ml-3 transition-opacity duration-300">{item.label}</span>
                  )}
                </button>
              )}
              
              {/* Reports Submenu */}
              {isOpen && item.key === 'reports' && isReportsOpen && (
                <div className="bg-[#2f354a] dark:bg-gray-700 py-1">
                  {reportsSubMenu.map((subItem, subIndex) => (
                    <button
                      key={subIndex}
                      onClick={() => {
                        navigate(subItem.path);
                        if (isMobile && onCloseSidebar) {
                          onCloseSidebar();
                        }
                      }}
                      className="w-full flex items-center py-2 px-8 text-[#8d969d] dark:text-gray-400 hover:text-white dark:hover:text-white hover:bg-[#181f27] dark:hover:bg-gray-600 text-sm"
                    >
                      <span className="inline-block">{subItem.icon}</span>
                      <span className="ml-3">{subItem.label}</span>
                    </button>
                  ))}
                </div>
              )}
              
              {/* Settings Submenu */}
              {isOpen && item.key === 'settings' && isSettingsOpen && (
                <div className="bg-[#2f354a] dark:bg-gray-700 py-1">
                  {settingsSubMenu.map((subItem, subIndex) => (
                    <button
                      key={subIndex}
                      onClick={() => {
                        navigate(subItem.path);
                        if (isMobile && onCloseSidebar) {
                          onCloseSidebar();
                        }
                      }}
                      className="w-full flex items-center py-2 px-8 text-[#8d969d] dark:text-gray-400 hover:text-white dark:hover:text-white hover:bg-[#181f27] dark:hover:bg-gray-600 text-sm"
                    >
                      <span className="inline-block">{subItem.icon}</span>
                      <span className="ml-3">{subItem.label}</span>
                    </button>
                  ))}
                </div>
              )}
              
              {/* Timesheet Submenu */}
              {isOpen && item.key === 'timesheet' && isTimesheetOpen && (
                <div className="bg-[#2f354a] dark:bg-gray-700 py-1">
                  {timesheetSubMenu.map((subItem, subIndex) => (
                    <button
                      key={subIndex}
                      onClick={() => {
                        navigate(subItem.path);
                        if (isMobile && onCloseSidebar) {
                          onCloseSidebar();
                        }
                      }}
                      className="w-full flex items-center py-2 px-8 text-[#8d969d] dark:text-gray-400 hover:text-white dark:hover:text-white hover:bg-[#181f27] dark:hover:bg-gray-600 text-sm"
                    >
                      <span className="inline-block">{subItem.icon}</span>
                      <span className="ml-3">{subItem.label}</span>
                    </button>
                  ))}
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Sidebar; 